export { default as tiktokService } from './tiktok-service'